// @generated by protoc-gen-es v2.11.0 with parameter "target=js+dts,valid_types=legacy_required+protovalidate_required"
// @generated from file openmoney/accounts/v1/accounts_service.proto (package openmoney.accounts.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_type_money } from "../../../google/type/money_pb";

/**
 * Describes the file openmoney/accounts/v1/accounts_service.proto.
 */
export const file_openmoney_accounts_v1_accounts_service = /*@__PURE__*/
  fileDesc("CixvcGVubW9uZXkvYWNjb3VudHMvdjEvYWNjb3VudHNfc2VydmljZS5wcm90bxIVb3Blbm1vbmV5LmFjY291bnRzLnYxInEKB0FjY291bnQSFAoCaWQYASABKAlCCLpIBXIDsAEBEhgKBG5hbWUYAiABKAlCCrpIB3IFEAEY+gESDwoHYmFsYW5jZRgDIAEoBRIlCgFtGAQgASgLMhIuZ29vZ2xlLnR5cGUuTW9uZXlCBrpIA8gBASINCgtMaXN0UmVxdWVzdCJACgxMaXN0UmVzcG9uc2USMAoIYWNjb3VudHMYASADKAsyHi5vcGVubW9uZXkuYWNjb3VudHMudjEuQWNjb3VudCIpCg5HZXRCeUlkUmVxdWVzdBIXCgJpZBgBIAEoCUILukgIyAEBcgOwAQEiQgoPR2V0QnlJZFJlc3BvbnNlEi8KB2FjY291bnQYASABKAsyHi5vcGVubW9uZXkuYWNjb3VudHMudjEuQWNjb3VudCI9Cg1DcmVhdGVSZXF1ZXN0EhsKBG5hbWUYASABKAlCDbpICsgBAXIFEAEY+gESDwoHYmFsYW5jZRgCIAEoBSJBCg5DcmVhdGVSZXNwb25zZRIvCgdhY2NvdW50GAEgASgLMh4ub3Blbm1vbmV5LmFjY291bnRzLnYxLkFjY291bnQicgoNVXBkYXRlUmVxdWVzdBIXCgJpZBgBIAEoCUILukgIyAEBcgOwAQESHQoEbmFtZRgCIAEoCUIKukgHcgUQARj6AUgAiAEBEhQKB2JhbGFuY2UYAyABKAVIAYgBAUIHCgVfbmFtZUIKCghfYmFsYW5jZSJBCg5VcGRhdGVSZXNwb25zZRIvCgdhY2NvdW50GAEgASgLMh4ub3Blbm1vbmV5LmFjY291bnRzLnYxLkFjY291bnQiJQoNRGVsZXRlUmVxdWVzdBIUCgJpZBgBIAEoCUIIukgFcgOwAQEiEAoORGVsZXRlUmVzcG9uc2UyywMKD0FjY291bnRzU2VydmljZRJRCgRMaXN0EiIub3Blbm1vbmV5LmFjY291bnRzLnYxLkxpc3RSZXF1ZXN0GiMub3Blbm1vbmV5LmFjY291bnRzLnYxLkxpc3RSZXNwb25zZSIAEloKB0dldEJ5SWQSJS5vcGVubW9uZXkuYWNjb3VudHMudjEuR2V0QnlJZFJlcXVlc3QaJi5vcGVubW9uZXkuYWNjb3VudHMudjEuR2V0QnlJZFJlc3BvbnNlIgASVwoGQ3JlYXRlEiQub3Blbm1vbmV5LmFjY291bnRzLnYxLkNyZWF0ZVJlcXVlc3QaJS5vcGVubW9uZXkuYWNjb3VudHMudjEuQ3JlYXRlUmVzcG9uc2UiABJXCgZVcGRhdGUSJC5vcGVubW9uZXkuYWNjb3VudHMudjEuVXBkYXRlUmVxdWVzdBolLm9wZW5tb25leS5hY2NvdW50cy52MS5VcGRhdGVSZXNwb25zZSIAElcKBkRlbGV0ZRIkLm9wZW5tb25leS5hY2NvdW50cy52MS5EZWxldGVSZXF1ZXN0GiUub3Blbm1vbmV5LmFjY291bnRzLnYxLkRlbGV0ZVJlc3BvbnNlIgBiBnByb3RvMw", [file_buf_validate_validate, file_google_type_money]);

/**
 * Describes the message openmoney.accounts.v1.Account.
 * Use `create(AccountSchema)` to create a new message.
 */
export const AccountSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 0);

/**
 * Describes the message openmoney.accounts.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 1);

/**
 * Describes the message openmoney.accounts.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 2);

/**
 * Describes the message openmoney.accounts.v1.GetByIdRequest.
 * Use `create(GetByIdRequestSchema)` to create a new message.
 */
export const GetByIdRequestSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 3);

/**
 * Describes the message openmoney.accounts.v1.GetByIdResponse.
 * Use `create(GetByIdResponseSchema)` to create a new message.
 */
export const GetByIdResponseSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 4);

/**
 * Describes the message openmoney.accounts.v1.CreateRequest.
 * Use `create(CreateRequestSchema)` to create a new message.
 */
export const CreateRequestSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 5);

/**
 * Describes the message openmoney.accounts.v1.CreateResponse.
 * Use `create(CreateResponseSchema)` to create a new message.
 */
export const CreateResponseSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 6);

/**
 * Describes the message openmoney.accounts.v1.UpdateRequest.
 * Use `create(UpdateRequestSchema)` to create a new message.
 */
export const UpdateRequestSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 7);

/**
 * Describes the message openmoney.accounts.v1.UpdateResponse.
 * Use `create(UpdateResponseSchema)` to create a new message.
 */
export const UpdateResponseSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 8);

/**
 * Describes the message openmoney.accounts.v1.DeleteRequest.
 * Use `create(DeleteRequestSchema)` to create a new message.
 */
export const DeleteRequestSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 9);

/**
 * Describes the message openmoney.accounts.v1.DeleteResponse.
 * Use `create(DeleteResponseSchema)` to create a new message.
 */
export const DeleteResponseSchema = /*@__PURE__*/
  messageDesc(file_openmoney_accounts_v1_accounts_service, 10);

/**
 * @generated from service openmoney.accounts.v1.AccountsService
 */
export const AccountsService = /*@__PURE__*/
  serviceDesc(file_openmoney_accounts_v1_accounts_service, 0);

